module.exports = __webpack_public_path__ + "images/corporate_buybacks_lp/icon_step04_04b2ada7c4b9ae2551795091a943ed10.png";